import { Link, Typography } from "@mui/material";
type Props = {};

const Creator = (props: Props) => {
  return (
    <Typography
      variant="body2"
      fontSize="small"
      textAlign="center"
      color="secondary.main"
      py={2}
      sx={{
        backgroundColor: "secondary.light",
        display: "flex",
        flexWrap: "nowrap",
        overflow: "auto",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      © 2024 Modern College Of Physiotherapy All Rights Reserved. Designed By
      -&nbsp;
      <Link
        href="https://www.akronsystems.com/Home.aspx"
        target="_blank"
        color={"primary.main"}
      >
        Akron Systems
      </Link>
    </Typography>
  );
};

export default Creator;
